import env from "../utils/env";
import { prepareHyHttpHeaders } from "../utils/http";

export function createProvidersFetcher() {
  let abortController;
  return function fetchProviders(searchParams) {
    if (abortController) {
      abortController.abort();
    }
    abortController = new AbortController();
    return fetch(`${env("BASE_HY_URL")}doctors${searchParams}`, {
      headers: prepareHyHttpHeaders(),
      signal: abortController.signal
    })
      .then(res => {
        abortController = new AbortController();
        return res;
      })
      .catch(() => {}); // dummy catch to catch abort
  };
}
